import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type { GetControlGroupCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetControlGroupCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

export const useGetControlGroupCount = createQueryHook<
  NavigationCountArgs,
  NavigationCounts,
  GetControlGroupCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    control_group_aggregate: { aggregate: toAggregate(data.controlGroup) },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetControlGroupCountDocument,
});
